/**
 * The time, as the server tells it. Which of two versions of a map is the newer is decided by
 * their timestamps, so every device stamps its changes on one clock — the server's — whatever
 * its own says. The difference is learnt from every sync answer and remembered.
 */
import { getKV, setKV } from '../store/idb.ts';

let skew = 0;

export function now(): number {
  return Date.now() + skew;
}

export async function loadClock(): Promise<void> {
  skew = (await getKV<number>('clockSkew')) ?? 0;
}

/** `serverTime` was read a moment ago (half a round trip at most): differences under a few seconds are the network, not the clock. */
export function noteServerTime(serverTime: number): void {
  const d = serverTime - Date.now();
  const next = Math.abs(d) < 5_000 ? 0 : Math.round(d);
  if (Math.abs(next - skew) < 2_000) return;
  skew = next;
  void setKV('clockSkew', skew).catch(() => {});
}
